import { put } from 'redux-saga/effects';
import ControllersActions from '../redux/ControllersRedux';
import i18n from '../i18n';
import decode from 'jwt-decode';

export function* getControllers(api, { pageParams }) {
  try {
    const getControllersResponse = yield api.getControllers(pageParams);
    if (getControllersResponse.ok) {
      yield put(
        ControllersActions.getControllersRequestSuccess(
          getControllersResponse.data.content,
          getControllersResponse.data.totalElements,
        ),
      );
    } else {
      api.checkAuth(getControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getControllersResponse.problem !== 'undefined'
          ? getControllersResponse.problem
          : typeof getControllersResponse.data.error !== 'undefined'
          ? getControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.getControllersRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.getControllersRequestFailure(error));
  }
}

export function* getControllerDetails(api, { controllerId }) {
  try {
    const getControllerDetailsResponse = yield api.getControllerDetails(controllerId);
    if (getControllerDetailsResponse.ok) {
      yield put(ControllersActions.getControllerDetailsRequestSuccess(getControllerDetailsResponse.data));
    } else {
      api.checkAuth(getControllerDetailsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getControllerDetailsResponse.problem !== 'undefined'
          ? getControllerDetailsResponse.problem
          : typeof getControllerDetailsResponse.data.error !== 'undefined'
          ? getControllerDetailsResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.getControllerDetailsRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.getControllerDetailsRequestFailure(error));
  }
}

export function* editController(api, { controllerId, controllerInfos, pageParams }) {
  try {
    const editControllerResponse = yield api.editController(controllerId, controllerInfos);
    const getControllersResponse = yield api.getControllers(pageParams);
    const successMessage = i18n.t('successMessage.editControllerSuccess');
    if (editControllerResponse.ok && getControllersResponse.ok) {
      yield put(
        ControllersActions.editControllerRequestSuccess(
          getControllersResponse.data.content,
          getControllersResponse.data.totalElements,
          successMessage,
        ),
      );
    } else {
      api.checkAuth(editControllerResponse);
      api.checkAuth(getControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editControllerResponse.problem !== 'undefined'
          ? editControllerResponse.problem
          : typeof editControllerResponse.data.error !== 'undefined'
          ? editControllerResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.editControllerRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.editControllerRequestFailure(error));
  }
}

export function* editControllerSettings(api, { controllerId, controllerSettings }) {
  try {
    const editControllerSettingsResponse = yield api.editControllerSettings(controllerId, controllerSettings);
    const getControllerDetailsResponse = yield api.getControllerDetails(controllerId);
    const successMessage = i18n.t('successMessage.editControllerSettingsSuccess');
    if (editControllerSettingsResponse.ok && getControllerDetailsResponse.ok) {
      yield put(
        ControllersActions.editControllerSettingsRequestSuccess(getControllerDetailsResponse.data, successMessage),
      );
    } else {
      api.checkAuth(editControllerSettingsResponse);
      api.checkAuth(getControllerDetailsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editControllerSettingsResponse.problem !== 'undefined'
          ? editControllerSettingsResponse.problem
          : typeof editControllerSettingsResponse.data.error !== 'undefined'
          ? editControllerSettingsResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.editControllerSettingsRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.editControllerSettingsRequestFailure(error));
  }
}

export function* deleteController(api, { controllerId, pageParams }) {
  try {
    const deleteControllerResponse = yield api.deleteController(controllerId);
    const getControllersResponse = yield api.getControllers(pageParams);
    const successMessage = i18n.t('successMessage.deleteControllerSuccess');
    if (deleteControllerResponse.ok && getControllersResponse.ok) {
      yield put(
        ControllersActions.deleteControllerRequestSuccess(
          getControllersResponse.data.content,
          getControllersResponse.data.totalElements,
          successMessage,
        ),
      );
    } else {
      api.checkAuth(deleteControllerResponse);
      api.checkAuth(getControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteControllerResponse.problem !== 'undefined'
          ? deleteControllerResponse.problem
          : typeof deleteControllerResponse.data.error !== 'undefined'
          ? deleteControllerResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.deleteControllerRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.deleteControllerRequestFailure(error));
  }
}

export function* uploadFile(api, { file }) {
  try {
    const uploadFileResponse = yield api.uploadFile(file);
    const successMessage = i18n.t('successMessage.uploadFileSuccess');
    if (uploadFileResponse.ok) {
      yield put(ControllersActions.uploadFileRequestSuccess(uploadFileResponse?.data, successMessage));
    } else {
      api.checkAuth(uploadFileResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof uploadFileResponse.problem !== 'undefined'
          ? uploadFileResponse.problem
          : typeof uploadFileResponse.data.error !== 'undefined'
          ? uploadFileResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.uploadFileRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.uploadFileRequestFailure(error));
  }
}

export function* updateControllers(api, { body }) {
  try {
    const updateControllersResponse = yield api.updateControllers(body);
    const successMessage = i18n.t('successMessage.updateControllersSuccess');
    if (updateControllersResponse.ok) {
      yield put(ControllersActions.updateControllersRequestSuccess(successMessage));
    } else {
      api.checkAuth(updateControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof updateControllersResponse.problem !== 'undefined'
          ? updateControllersResponse.problem
          : typeof updateControllersResponse.data.error !== 'undefined'
          ? updateControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(ControllersActions.updateControllersRequestFailure(error));
      console.log(error);
    }
  } catch (error) {
    console.log(error);
    yield put(ControllersActions.updateControllersRequestFailure(error));
  }
}

export function* getCustomersForController(api, { distributorId }) {
  try {
    const customersByDistributorResponse = distributorId
      ? yield api.getCustomersByDistributor(distributorId)
      : yield api.getCustomers();
    if (customersByDistributorResponse.ok) {
      const content = distributorId ? customersByDistributorResponse.data.content : customersByDistributorResponse.data;
      const customersWithSub = content.map((customer) => {
        const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
        const customerIdSub = decodedToken ? decodedToken.sub : null;
        return { ...customer, customerIdSub };
      });
      yield put(ControllersActions.getCustomersForControllerRequestSuccess(customersWithSub));
    } else {
      api.checkAuth(customersByDistributorResponse);
      const error =
        typeof customersByDistributorResponse.problem !== 'undefined'
          ? customersByDistributorResponse.problem
          : typeof customersByDistributorResponse.data.error !== 'undefined'
          ? i18n.t(customersByDistributorResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(ControllersActions.getCustomersForControllerRequestFailure(error));
    }
  } catch (error) {
    console.log('error in customers saga', error);
    yield put(ControllersActions.getCustomersByDistributorRequestFailure(error));
  }
}
